import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedLayout from './components/Auth/ProtectedLayout';
import UploadXML from './components/UploadXML';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ProtectedLayout />}>
          <Route index element={<UploadXML />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;